import type { StatsigOptions } from '@statsig/react-bindings';

import { BASE_CLIENT_OPTIONS } from '../constants';
import getStatsigOverrideAdapter from '../getOverrideAdapter';
import getEnvironmentTier from './getEnvironmentTier';

/**
 * Returns client options including the local override adapter and environment tier.
 * Use this instead of a static constant so the adapter is lazily created and SSR-safe.
 *
 * The environment tier tells the Statsig SDK which tier to use for evaluation
 * and to include in network requests to Gateway. In preview, this is 'staging';
 * in production it's undefined (Statsig's default).
 *
 * @see https://docs.statsig.com/guides/using-environments
 */
const getClientOptions = (): StatsigOptions => {
  const overrideAdapter = getStatsigOverrideAdapter();
  const tier = getEnvironmentTier();
  return {
    ...BASE_CLIENT_OPTIONS,
    ...(overrideAdapter != null && { overrideAdapter }),
    ...(tier !== undefined && { environment: { tier } }),
  };
};

export default getClientOptions;
